<template>
<v-container fill-height>
  <v-layout align-center> 
    <v-flex xs12 sm6 offset-sm3>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-container align-center class="materialized_ctn__form">
            <v-card-text>
              <v-text-field label="Username" v-model="username" :rules="nameRules" required @keyup.enter="login" ></v-text-field>
              <v-text-field label="Password" v-model="password" :rules="passwordRules" :type="'password'" required @keyup.enter="login" autocomplete="new-password"></v-text-field>
            </v-card-text>
            <v-card-actions style="justify-content: space-between;">
                <router-link to="/account/create" class="login-link"  >Register</router-link>
                <v-btn v-on:click="login" color="secondary" class="materialized">Login</v-btn>
            </v-card-actions>

              <v-snackbar
                v-model="showmessage"
                bottom="bottom"
                right="right"
                :timeout="6000"
                >
                <span>{{ alertMessage }}</span>
                <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
            </v-snackbar> 
          </v-container>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import Account from '../../services/Account.js'

export default {
    name: "AccountLogin",
    data() {
    return {
      valid: true,
      username: "",
      nameRules: [v => !!v || "Username is required"],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      secret: "10a707c50f4511e7ad2110c37b9e1954",
      secretRules: [v => !!v || "Secret is required"],
      client: "team.com",
      clientRules: [v => !!v || "Client is required"],
      showmessage: false,
      alertMessage: ""
    };
  },
  methods: {
    login() {
      Account.requestToken({ username: this.username, password: this.password }).then(function (response) {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        this.$router.push({ name: 'Home1' });
      }.bind(this));
    }
  }
}
</script>
